module.exports = __webpack_public_path__ + "static/media/expPink.cc38aec5.svg";